import { render, staticRenderFns } from "./VistaEditorNoticiasCaritas.vue?vue&type=template&id=3d4af3e8"
import script from "./VistaEditorNoticiasCaritas.vue?vue&type=script&lang=js"
export * from "./VistaEditorNoticiasCaritas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports